<template>
  <div>

    <router-link
      :to="{name: 'apps-mstsupplier-list'}"
      class="text-decoration-none text-white"
    >
      <b-button
        class="mb-1"
        variant="primary"
      >
        <feather-icon
          icon="ArrowLeftIcon"
          class="mr-75"
        />
        Kembali
      </b-button>
    </router-link>
    <b-card>
      <!-- required required Wajib diisi -->
      <!-- min:x min:3 Minimal x karakter -->
      <!-- max:x max:10 Maksimal x karakter -->
      <!-- email email Format email valid -->
      <!-- numeric numeric Hanya angka -->
      <!-- between:x,y between:1,10 Antara nilai x dan y -->
      <!-- confirmed confirmed:password Cocok dengan field lain -->
      <validation-observer ref="simpleRules">
        <b-form>
          <b-row>
            <!-- Nama Supplier -->
            <b-col
              xl="6"
              md="12"
            >
              <b-form-group
                label="Nama Supplier"
                label-for="name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="name"
                  rules="required"
                >
                  <b-form-input
                    id="name"
                    v-model="name"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Masukkan Nama Supplier"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider></b-form-group>

              <!-- Phone -->
              <b-form-group
                label="No HP"
                label-for="category"
              >
                <validation-provider
                  #default="{ errors }"
                  name="phone"
                  rules="required"
                >
                  <b-input-group>
                    <b-input-group-prepend is-text>
                      +62
                    </b-input-group-prepend>
                    <cleave
                      id="phone"
                      v-model="phone"
                      class="form-control"
                      :raw="false"
                      :options="options.phone"
                      placeholder="81234567890"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider></b-form-group>

              <!-- email -->
              <b-form-group
                label="Email"
                label-for="email"
              >

                <b-form-input
                  id="email"
                  v-model="email"
                  placeholder="Masukkan Email"
                />
              </b-form-group>
            </b-col>

            <!-- Alamat -->
            <b-col
              xl="6"
              md="12"
            >
              <b-form-group
                label="Alamat"
                label-for="address"
              >
                <b-form-textarea
                  id="address"
                  v-model="address"
                />
              </b-form-group>

              <!-- Bank Akun -->
              <b-form-group
                label="Nama Rekening"
                label-for="bank_account"
              >

                <b-form-input
                  id="bank_account"
                  v-model="bank_account"
                  placeholder="Masukkan Nama Rekening"
                />
              </b-form-group>

              <!-- Bank Name -->
              <b-form-group
                label="Bank"
                label-for="bank_name"
              >

                <b-form-input
                  id="bank_name"
                  v-model="bank_name"
                  placeholder="BCA"
                />
              </b-form-group>

              <!-- Bank Rek -->
              <b-form-group
                label="No Rekening"
                label-for="bank_number"
              >

                <b-form-input
                  id="bank_number"
                  v-model="bank_number"
                  placeholder="Masukkan No Rekening"
                />

              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <!-- Tombol Aksi -->
            <b-col
              md="12"
            >
              <b-button
                type="submit"
                variant="success"
                class="mr-1"
                @click.prevent="validationForm"
              >
                Simpan
              </b-button>
              <b-button
                type="reset"
                variant="outline-secondary"
              >
                Reset
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer></b-card>

  </div>
</template>

<script>
import {
  BFormInput, BFormGroup, BRow, BCol, BButton, BCard, BForm, BFormTextarea, BInputGroupPrepend, BInputGroup,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
// eslint-disable-next-line import/no-cycle
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import Cleave from 'vue-cleave-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BRow,
    BForm,
    BCol,
    BButton,
    BCard,
    BFormTextarea,
    BInputGroup,
    BInputGroupPrepend,
    Cleave,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      name: null,
      address: null,
      phone: null,
      npwp: null,
      bank_number: null,
      bank_account: null,
      bank_name: null,
      required,
      options: {
        date: {
          date: true,
          delimiter: '-',
          datePattern: ['Y', 'm', 'd'],
        },
        phone: {
          phone: true,
          phoneRegionCode: 'ID',
        },
        time: {
          time: true,
          timePattern: ['h', 'm', 's'],
        },
        number: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
        },
        block: {
          blocks: [4, 3, 3],
          uppercase: true,
        },
        delimiter: {
          delimiter: '·',
          blocks: [3, 3, 3],
          uppercase: true,
        },
        customDelimiter: {
          delimiters: ['.', '.', '-'],
          blocks: [3, 3, 3, 2],
          uppercase: true,
        },
        prefix: {
          prefix: '+63',
          blocks: [3, 3, 3, 4],
          uppercase: true,
        },
      },
    }
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  methods: {
    submitSupplier() {
      const payload = {
        name: this.name,
        address: this.address,
        phone: this.phone,
        npwp: this.npwp,
        bank_number: this.bank_number,
        bank_account: this.bank_account,
        bank_name: this.bank_name,
      }

      this.$http.post('/supplier/add', payload)
        .then(() => {
          this.$bvToast.toast('Supplier berhasil ditambahkan!', {
            title: 'Sukses',
            variant: 'success',
            solid: true,
          })
          // Reset redirect
          this.$router.push({ name: 'master-supplier-list' })
        })
        .catch(err => {
          const message = err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Gagal menyimpan data supplier.'

          console.error(err)

          this.$bvToast.toast(message, {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitSupplier()
        } else {
          this.$bvToast.toast('Lengkapi Data Sebelum Submit!', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        }
      })
    },
  },
}
</script>
